/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ when: NonNullable<unknown> }} Tea_Grade_Stock_Lot_ScentedInputs */

const vi_tea_grade_stock_lot_scented = /** @type {(inputs: Tea_Grade_Stock_Lot_ScentedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Lấy hương ${i?.when}`)
};

/**

* @param {Tea_Grade_Stock_Lot_ScentedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_grade_stock_lot_scented = /** @type {((inputs: Tea_Grade_Stock_Lot_ScentedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Grade_Stock_Lot_ScentedInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_grade_stock_lot_scented(inputs)
});